import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizContainer } = framework_tool
const { isType } = utils_tool
import 'antd/dist/antd.css';
import {Button} from 'antd';
let {WizForm,WizSelect, WizRow,WizCol, WizIcon, WizTooltip } = component_tool;
class BatchEditor extends WizContainer {
  componentName = 'batchEditor'

  constructor(props) {
    super(props)
    this.state = {
      timestamp: new Date().getTime(),
      selectedRows: [],
      ids: [],
      operationMode:'',
    };
    this.initTargetKeys = [];
    this.initTargetRows = [];
    this.values = {};
    this.record={};
  }

  _componentWillMount() {
    const { rows = [] ,record={} ,operationMode=''} = this.props;
    this.state.operationMode=operationMode;
    if (operationMode!=undefined && operationMode!=null && operationMode!=''){
      if (operationMode==='all'){
        let rows_ = [];
        rows.forEach(data => {
          rows_.push({...data})
          this.state.ids.push(data.id);
          this.initTargetKeys.push(data.id);
        });
        this.state.selectedRows = rows_;
        this.initTargetRows = rows_;
      }else if (operationMode==='alone'){
        this.record=record;
      }
    }
  }


  _ok = (data) => {
    let fitterValues = this.fitterFieldsValue(data);
    const {ids } = this.state;
    const { record={} ,operationMode=''} = this.props;
    let idList = [];
    if (operationMode==='all' && ids.length === 0){
      wizNotice.error("请选择资源账号");
      return ;
    }else if (operationMode==='all' && ids.length > 0){
      ids.forEach(id =>{
        idList.push(id);
      })
    }else if (operationMode==='alone' && record && record.id ) {
      const {id} = record;
      idList.push(id);
    }else {
      wizNotice.error("请选择资源账号");
      return ;
    }
    if (idList.length === 0){
      wizNotice.error("请选择资源账号");
      return ;
    }else {
      this.doAction({
        path: 'interactLiveResources/updateResourcesState',
        payload: {
          key: 'interactLiveResources@updateResourcesState',
          apiParams: {...fitterValues,idList:idList}
        }
      })
    }
  }


  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(data) {
    let fitterValues = {};
    Object.keys(data).forEach(key => {
      const value = data[key];
      if (key === 'expirationTime' && value != null && value != undefined) {
        fitterValues['expirationTime'] = value.format("YYYY-MM-DD HH:mm:ss");
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  propsAndStateOnChange = {
    save: this._saveOnChange.bind(this)
  }

  _saveOnChange(nextProps, nextState) {
    if (nextProps.save.code === 1) {
      wizNotice.success('操作成功')
      this.props.changeModal(false, true);
      let { editorSuccess } = this.props
      editorSuccess && editorSuccess()
    } else {
      wizNotice.error(nextProps.save.msg)
    }
  }

  //select中的change事件
  _wizSelectOnChange(value, option) {
    let classify = value.map(select => select.key)
    let selectedRows = this.state.selectedRows.filter(filter => classify.indexOf(filter.key) !== -1)
    const selectIds = [];
    selectedRows.forEach(data => {
      selectIds.push(data.id)
    })
    this.setState({
      selectedRows: selectedRows,
      ids: selectIds
    });
  }


  /**
   * 初始化已选人员
   */
  _doInitParams = () => {
    this.onChange(this.initTargetKeys, this.initTargetRows)
  };

  onChange = (nextTargetKeys, nextTargetRows) => {
    this.setState({
      ids: nextTargetKeys,
      selectedRows: nextTargetRows
    });
  };

  _renderOptions(selectedRows) {
    if (selectedRows && selectedRows.length) {
      return selectedRows.map((row, i) => this._renderOption(row))
    }
    return null
  }

  _renderOption(row) {
    if (row) {
      const userEmail = row.userEmail;
      return (
        <WizSelect.Option key={row.id} value={userEmail} title={userEmail}>
          {userEmail}
        </WizSelect.Option>
      )
    }
  }


  handleClear(id) {
    id
      ? this.setState({
        selectedRows: this.state.selectedRows.filter(item => item.id !== id),
        ids: this.state.ids.filter(item => item !== id)
      })
      : this.setState({
        selectedRows: [],
        ids: []
      });
  }

  render() {
    //rows
    const { rows = [] ,record={} ,operationMode='',operationUpdateMode=''} = this.props
    const ids = this.state.ids;
    log.info('this.props',this.props);
    let selectKey = this.state.selectedRows.map(selected => selected.id).join(",");
    const selectedRows = this.state.selectedRows;
    selectedRows.forEach(data => {
      data.key = data.id,
        data.label = data.userEmail
    });
    const header = (
      <div style={{paddingLeft: 15, paddingBottom: 12}}>
        已选资源账号<strong> {selectedRows.length} </strong> {'个'}
        <Button type="link" onClick={() => this.handleClear()}>清除选择</Button>
      </div>
    );

    const columns = [
      {
        name: "idList",
        formItem: {
          type: 'hidden',
          initialValue: {ids}
        },
      },
      {
        name: "status",
        formItem: {
          type: 'hidden',
          initialValue: 1
        },
      },
      operationMode === 'all' ? {
        formItem: {
          type: 'custom',
          col: { span: 21 },
          formItemLayout: {
            labelCol: { span: 0 },
            wrapperCol: { span: 24 }
          },
          render: (record, form) => {
            return (
              <>
                {header} <WizSelect
                style={{width: '100%', paddingLeft: 15}}
                key={'wizSelect_' + selectKey}
                defaultValue={this.state.selectedRows}
                labelInValue
                mode={'multiple'}
                open={false}
                onChange={(value, option) => this._wizSelectOnChange(value, option)}
              >
                {this._renderOptions(selectedRows)}
              </WizSelect></>
            )
          }
        }
      } :{},
      operationMode !== 'all' ?
        {
          title: "第三方使用邮箱",
          name: "userName",
          formItem: {
            initialValue:  record && record.userEmail,
            disabled:true
          }
        }: {},
      {
        title: '资源账号类型',
        name: 'type',
        dataIndex: 'type',
        formItem: {
          type: 'select',
          initialValue:  record && record.type,
          rules: [{ required: operationUpdateMode==='update' ? true : false, message: '请选择资源账号类型' }],
        },
        dict: [
          {code: 1, codeName: '远程评估 '},
          {code: 2, codeName: '直播课堂/远程认证'}
        ]
      },
      {
        title: "用户付费类型",
        name: "userType",
        dataIndex: "userType",
        formItem: {
          type: 'select',
          initialValue:  record && record.userType,
          rules: [{ required: operationUpdateMode==='update' ? true : false, message: '请选择用户付费类型' }],
        },
        dict: [
          {code: 1, codeName: '免费用户'},
          {code: 2, codeName: '授权用户'},
          {code: 3, codeName: '预置用户'},
        ]
      },
      {
        title: "账号到期时间",
        name: "expirationTime",
        dataIndex: "expirationTime",
        formItem: {
          type: 'date',
          initialValue:  operationUpdateMode==='update' && record && record.expirationTime ? record.expirationTime : null,
          disabled: operationUpdateMode==='update' ? true : false
        }
      },
      {
        formItem: {
          type: 'custom',
          col: { span: 21 },
          formItemLayout: {
            labelCol: { span: 0 },
            wrapperCol: { span: 24 }
          },
          render: () => {
            return <span style={{color: 'red'}}>{'注意：未选择资源账号类型以及用户付费类型，则直接根据原有默认设置激活'}</span>
          }
        }
      },
    ]

    const formProps = {
      key: this.state.timestamp,
      ref: 'form',
      columns,
      record:null,
      preview: false,
      onSubmit: this._ok,
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 }
      }
    }

    return (
      <div>
        <WizForm {...formProps} />
      </div>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  const { interactLiveResources } = state
  const save = modelUtils.getModelEntity(interactLiveResources, 'interactLiveResources@updateResourcesState')
  return {
    save
  }
}

const options = { withRef: true }

export default connect(mapStateToProps, null, null, options)(BatchEditor)
